import { render, staticRenderFns } from "./benefits-point-reward-panel.vue?vue&type=template&id=0af42fd8&scoped=true"
import script from "./benefits-point-reward-panel.vue?vue&type=script&lang=js"
export * from "./benefits-point-reward-panel.vue?vue&type=script&lang=js"
import style0 from "./benefits-point-reward-panel.vue?vue&type=style&index=0&id=0af42fd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af42fd8",
  null
  
)

export default component.exports